import client from "./axios";

const ENV = `${process.env.REACT_APP_BACKEND_URL}/pages`;

export const getPages = async () => {
  try {
    const pages = await client.get(`${ENV}`);
    return pages;
  } catch (error: any) {
    console.log("getPages----", error?.message as string);
  }
};

export const getCreatorMarketplaceCreators = async (
  pageDocId: string,
  params: {
    query?: string;
    creator_countries?: string;
    limit?: number;
    username?: string;
  } = {}
) => {
  const search = new URLSearchParams();
  if (params.username != null && params.username !== "")
    search.set("username", params.username);
  if (params.query != null && params.query !== "")
    search.set("query", params.query);
  if (params.creator_countries != null && params.creator_countries !== "")
    search.set("creator_countries", params.creator_countries);
  if (params.limit != null) search.set("limit", String(params.limit));
  const qs = search.toString();
  try {
    const res = await client.get(
      `${ENV}/creator-marketplace/${pageDocId}${qs ? `?${qs}` : ""}`
    );
    return res;
  } catch (error: any) {
    console.log("getCreatorMarketplaceCreators----", error?.message as string);
    throw error;
  }
};

// Send a Partnership-folder message to a creator (Creator Marketplace Messaging).
export const sendCreatorMessage = async (payload: {
  pageDocId?: string;
  messagingId: string;
  text: string;
  username?: string;
}) => {
  const res = await client.post(`${ENV}/creator-message`, payload);
  return res.data;
};

// Creators already messaged, with 30-day send count + 2/30-day cap flag.
export const getPartnershipContacts = async () => {
  const res = await client.get(`${ENV}/partnership-contacts`);
  return res.data;
};

// List threads in the brand's Partnership folder (Creator Marketplace Messaging).
export const getPartnershipConversations = async (pageDocId?: string) => {
  const res = await client.get(`${ENV}/partnership-conversations`, {
    params: pageDocId ? { pageDocId } : {},
  });
  return res.data;
};

// Messages within a Partnership-folder thread.
export const getPartnershipMessages = async (
  conversationId: string,
  pageDocId?: string
) => {
  const res = await client.get(
    `${ENV}/partnership-messages/${conversationId}`,
    { params: pageDocId ? { pageDocId } : {} }
  );
  return res.data;
};

export const addPage = async ({
  accessToken,
  category,
  name,
  pageId,
  connectedId,
  followers,
  following,
  about,
  picture,
  username
}: {
  accessToken: string;
  category: string;
  name: string;
  pageId: string;
  connectedId: string;
  followers: string;
  following: string;
  about: string;
  picture: string;
  username: string;
}) => {
  try {
    const page = await client.post(`${ENV}/add`, {
      accessToken,
      category,
      name,
      pageId,
      connectedId,
      followers,
      following,
      about,
      picture,
      username
    });
    return page;
  } catch (error: any) {
    console.log("addPage----", error?.message as string);
  }
};
